module.exports = __webpack_public_path__ + "media/country_flags/tz-6a0d462c.png";